import SubmitPublicRoleplay from '../Components/SubmitPublicRoleplay/SubmitPublicRoleplay';
import { useParams, Redirect } from 'react-router-dom';
const SubmitPublicInteractiveRoleplay = () => {
  const { token } = useParams();

  return !token ? <Redirect to="/" /> : <SubmitPublicRoleplay />;
};

export default SubmitPublicInteractiveRoleplay;
